export const BACKEND_URL = '/api';
export const BASE_URL = 'https://www.gwtp.net';
//export const BASE_URL = 'http://gwtp.test';
export const IMAGE_BASE_URL = BASE_URL;
export const CONTENT_URL = `${BASE_URL}/content`;
